import {style} from '@vanilla-extract/css'

export const tab = style({
  maxWidth: '100%',
})
